import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78e3e3a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex gap-1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Carregando preços "),
  /*#__PURE__*/_createElementVNode("div", { class: "flex gap-1" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "dot one" }, "."),
    /*#__PURE__*/_createElementVNode("span", { class: "dot two" }, "."),
    /*#__PURE__*/_createElementVNode("span", { class: "dot three" }, ".")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_View = _resolveComponent("View")!

  return (_openBlock(), _createBlock(_component_View, { "secondary-text": "Por favor, aguarde alguns segundos." }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}